<template>
  <div class="my-2 md:flex justify-between">
    <ul class="flex m-2">
      <li class="mr-2">
        <button-icon
          :color="'text-white'"
          :style="'bg-gray-700'"
          :tippy_content="'Create list'"
          ><i class="fas fa-list"></i
        ></button-icon>
      </li>
      <li class="mr-2">
        <button-icon
          :style="'bg-gray-700'"
          :color="'text-white'"
          :tippy_content="'Add to watchlist'"
          ><i class="fas fa-plus"></i
        ></button-icon>
      </li>
      <li class="mr-2">
        <button-icon
          :style="'bg-gray-700'"
          :color="'text-white'"
          :tippy_content="'Add to favourite'"
          ><i class="fas fa-heart"></i
        ></button-icon>
      </li>
      <li v-if="videos && videos.results.length">
        <button-icon
          :style="'bg-gray-700'"
          :color="'text-white'"
          @click="toggleMovieModal"
          ><i class="fas fa-play"></i
        ></button-icon>
      </li>
    </ul>
    <div class="hidden md:block flex-1" />
    <ul class="flex m-2">
      <li class="mr-2" v-if="externalIds && externalIds.facebook_id">
        <a
          :href="`https://facebook.com/${externalIds.facebook_id}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text-white font-semibold"
        >
          <button-icon :style="'bg-blue-500'" :color="'text-white'"
            ><i class="fab fa-facebook-f"></i></button-icon
        ></a>
      </li>
      <li class="mr-2" v-if="externalIds && externalIds.twitter_id">
        <a
          :href="`https://twitter.com/${externalIds.twitter_id}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text-white font-semibold"
          ><button-icon :style="'bg-blue-500'" :color="'text-white'"
            ><i class="fab fa-twitter"></i></button-icon
        ></a>
      </li>
      <li class="mr-2" v-if="externalIds && externalIds.instagram_id">
        <a
          :href="`https://instagram.com/${externalIds.instagram_id}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text-white font-semibold"
        >
          <button-icon :style="'bg-gray-700'" :color="'text-white'"
            ><i class="fab fa-instagram"></i
          ></button-icon>
        </a>
      </li>
      <li class="mr-2" v-if="homepage">
        <a
          :href="homepage"
          target="_blank"
          rel="noopener noreferrer"
          class="text-white font-semibold"
        >
          <button-icon :style="'bg-gray-700'" :color="'text-white'"
            ><i class="fas fa-link"></i
          ></button-icon>
        </a>
      </li>
    </ul>
    <!-- Modal Movie -->
    <div v-if="videos && videos.results.length">
      <modal-movie
        :show="showMovieModal"
        @closeModal="toggleMovieModal"
        :video="videos.results[0].key"
      />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "actions",
  props: {
    externalIds: Object,
    homepage: String,
    videos: Object
  },
  setup() {
    const showMovieModal = ref(false);

    let toggleMovieModal = () => {
      showMovieModal.value = !showMovieModal.value;
    };

    return { showMovieModal, toggleMovieModal };
  }
};
</script>

<style></style>
